module.exports = __webpack_public_path__ + "static/media/Salvation - Church in Crisis.5e40aaf8.docx";